import { render, staticRenderFns } from "./dataSummary.vue?vue&type=template&id=df72052c&scoped=true"
import script from "./dataSummary.vue?vue&type=script&lang=js"
export * from "./dataSummary.vue?vue&type=script&lang=js"
import style0 from "./dataSummary.vue?vue&type=style&index=0&id=df72052c&prod&lang=scss&scoped=true"
import style1 from "./dataSummary.vue?vue&type=style&index=1&id=df72052c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df72052c",
  null
  
)

export default component.exports